import Vue from 'vue'
import VueCookie from 'vue-cookie'
import 'wicg-inert'
import 'flickity'
import 'flickity-imagesloaded'
import Tobii from '@midzer/tobii'
import lazyLoadImages from './lazy-load-images'
import gallery360 from './gallery-360'
import * as header from './header'
import * as dealerbookHeader from './dealerbook-header'
import handleSearch from './search'
import cardFilters from './card-filters'
import moreInfoToggle from './more-info-toggle'
import bikeIntroPanelsToggle from './bike-intro-panels-toggle'
import BikeHero from './_vue/components/BikeHero.vue'
import ModBikeGrid from './_vue/components/ModBikeGrid'
import DistributorForm from './_vue/components/DistributorForm'
import BikeRegistration from './_vue/components/BikeRegistration'
import Newsletter from './_vue/components/Newsletter'
import ContactForm from './_vue/components/ContactForm'
import LanguageSwitcher from './_vue/components/LanguageSwitcher'
import CookieBanner from './_vue/components/CookieBanner'
import EcoSignup from './_vue/components/EcoSignup'
import DealerbookTabs from './_vue/components/DealerbookTabs'
import DealerFinder from "./_vue/components/DealerFinder.vue";
import DeployTest from './_vue/components/DeployTest'
import PromoModal from './_vue/components/PromoModal.vue'
import AdjustableGeometry from './_vue/components/AdjustableGeometry.vue'
import ShipEarlyProductLocator from './_vue/components/ShipEarly/ProductLocator.vue'
import ShipEarlyBuyButton from './_vue/components/ShipEarly/BuyButton.vue';
import PressReleaseFamilies from "./_vue/components/PressReleaseFamilies.vue";
import * as findDealer from './find-a-dealer'
import _ from 'lodash';

window._ = _;

// ============================================================================
// Important notes:
//  - Any (s)css-bearing components imported and registered below will have
//    their rendered CSS included in the final payload. So, be sure to *only*
//    import and register components this project is definitely using.
// ============================================================================

// Import the components that this project will utilize.
// import ComponentName from './components/ComponentName'

Vue.use(VueCookie)

new Vue({
    el: '#app',
    delimiters: ['${', '}'],
    data() {
        return {
            languageSelectorVisible: false,
            languageSelectorShowCloseButton: true
        }
    },
    components: {
        'adjustable-geometry': AdjustableGeometry,
        'mod-bike-grid': ModBikeGrid,
        'distributor-form': DistributorForm,
        'bike-registration': BikeRegistration,
        'newsletter': Newsletter,
        'contact-form': ContactForm,
        'language-switcher': LanguageSwitcher,
        'cookie-banner': CookieBanner,
        'eco-signup': EcoSignup,
        'dealerbook-tabs': DealerbookTabs,
        'dealer-finder': DealerFinder,
        'deploy-test': DeployTest,
        'promo-modal': PromoModal,
        'bike-hero': BikeHero,
        'ship-early-product-locator': ShipEarlyProductLocator,
        'ship-early-buy-button': ShipEarlyBuyButton,
        'press-release-families': PressReleaseFamilies
    },
    methods: {
        openLanguageSelector() {
            this.languageSelectorShowCloseButton = true;
            this.languageSelectorVisible = true;
            this.$refs.refls.setComponentFocus('close');
        },
        closeLanguageSelector() {
            this.languageSelectorVisible = false;
            setTimeout(() => {
                this.setFocusToLanguageSelectorButton()
            }, 1);
        },
        setFocusToLanguageSelectorButton() {
            let btn = document.querySelector('.lang-btn').focus();
        }
    },
    mounted() {
        header.initialize()
        dealerbookHeader.initialize()
        handleSearch()
        lazyLoadImages()
        gallery360()
        cardFilters()
        moreInfoToggle()
        bikeIntroPanelsToggle()
        findDealer.initialize()
        // https://github.com/midzer/tobii
        const tobii = new Tobii({
            counter: false,
            draggable: false,
            zoom: false
        })

        // ========================================================================
        // MICHAEL (Feb 10, 2022): because the language selector is no longer using
        // Tobii, we need to replicate the accessibility features it provided. This
        // is what we need to do in Vue, depending on the situation:
        //
        // == Via Cookie Check ====================================================
        //
        // When the language selector is opened:
        // 1. add 'inert' attribute to <header>, <main>, and <footer>
        // 2. .lang-selector__body gets focused
        //
        // When the language selector is closed (by being forced to choose a language):
        // 1. do nothing because the page gets refreshed, which undoes all of the
        //    above by default (nice)
        //
        // == Via Clicking Flag Button ============================================
        //
        // When the language selector is opened:
        // 1. add 'inert' attribute to <header>, <main>, and <footer>
        // 2. .lang-selector__close gets focused
        //
        // When the language selector is closed by choosing a language:
        // 1. do nothing because the page gets refreshed, which undoes all of the
        //    above by default (nice)
        //
        // When the language selector is closed by clicking the X button:
        // 1. remove 'inert' attribute from <header>, <main>, and <footer>
        // 2. .lang-btn gets focused
        // ========================================================================

        let siteCookieSet = this.$cookie.get('site-set')

        if (!siteCookieSet)
        {
            this.languageSelectorShowCloseButton = false;
            this.languageSelectorVisible = true;
            this.$refs.refls.setComponentFocus('body');
        }
    }
})
